<!-- 评论卡片 -->
<template>
  <div class="comment-card" @click="() => $emit('click')"
      :style="{
        '--limit-image-number': imgLimit
      }"
    >
    <!-- 评论星星数 -->
    <div class="comment-card__title">
      <commentsstar class="comment-card__star" :disabled="true" :average_rating="data.rating" :font_size="22" />
      <span class="comment-card__date">{{ data.comment_date }}</span>
    </div>
    <!-- 评论者 -->
    <div class="comment-card__commenter">
      <span class="comment-card__name secondary_title">{{ data.name }}</span>
      <country-flag
        class="comment-card__flag"
        v-if="data.country"
        :country="data.country == 'UK' ? 'GB' : data.country"
        size="small"
      />
      <span class="comment-card__country">
        {{ data.country }}
      </span>
    </div>

    <!-- 主题内容 -->
    <div class="comment-card__content">
      <!-- 评论内容 -->
      <p class="comment-card__detail" v-text="data.content"></p>

      <!-- 图片 -->
      <div class="comment-card__comment-img" v-if="gallery && gallery.length > 0">
        <div class="comment-card__img-wrapper" v-for="(item, index) in gallery" :key="item.ID">
          <div class="comment-card__img">
            <v-lazy-img :dataUrl="item.url" />
            <div class="comment-card__img--more" v-if="index === imgLimit - 1 && otherImgNum > 0">
              + {{ otherImgNum + 1 }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品 -->
    <div class="comment-card__product" v-if="data.products">
      <product-info :procuts_info="data.products" />
    </div>
  </div>
</template>

<script>
import commentsstar from '@/js/components/view/comments/commentsstar.vue'
//import LazyImg from '@/js/components/LazyImg.vue'
import ProductInfo from '@/js/components/view/comments/productInfo.vue'
export default {
  components: { commentsstar,     CountryFlag: resolve => {require(['vue-country-flag'], resolve)}, ProductInfo },
  name: 'CommandCard',
  props: {
    data: {
      type: Object,
      require: true,
    },
    // 图片限制显示数量
    imgLimit: {
      type: Number,
      default: 5
    }
  },
  emits: ['click'],
  $emits: ['loaded'],
  computed: {
    gallery() {
      return this.data?.gallery?.slice(0, this.imgLimit)
    },
    otherImgNum() {
      return this.data?.gallery?.length - this.imgLimit
    }
  },
  data() {
    return {}
  },
  mounted() {
    //  已加载
    this.$emit('loaded')
  },
}
</script>

<style lang="scss" scoped>
.comment-card {
  padding: 24px;
  &__title {
    display: flex;
    align-items: center;
    height: 22px;
  }
  &__star {
    flex: 1;
  }
  &__date {
    line-height: 22px;
    font-size: 14px;
    color: #555;
  }
  &__commenter {
    margin-top: 14px;
    font-size: 18px;
    font-weight: bold;
  }
  &__name {
    margin-right: 6px;
  }
  &__country {
    margin-left: 6px;
  }
  &__flag {
    &.flag {
      transform: scale(0.36);
    }
  }
  &__content {
    padding-top: 14px;
  }
  &__detail {
    font-size: 16px;
    line-height: 24px;

    display: block;
    max-height: 72px; // 3 * 24

    // 多行文本溢出
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  &__comment-img {
    display: flex;
    margin-top: 12px;
    margin-left: -7px;
    margin-right: -7px;
  }
  &__img-wrapper {
    width: calc(100% / var(--limit-image-number));
    padding: 0 7px;
  }
  &__img {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    position: relative;
    img {
      position: absolute;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    &--more {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
    }
  }
  &__product {
    margin-top: 12px;
    ::v-deep {
      .comment_pro {
        border-color: #eee;
        padding-top: 24px;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0;
      }
      .comment_pro_left {
        height: 56px;
        width: 56px;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .comment_pro_right {
        font-size: 16px;
        line-height: 22px;
        display: block;
        max-height: 44px; // 2 * 22

        // 多行文本溢出
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
  @media screen and (max-width: 767px) {
    padding: 12px;
    &__commenter {
      margin-top: 13px;
      font-size: 16px;
      line-height: 22px;
    }
    &__date {
      font-size: 12px;
    }
    &__content {
      padding-top: 12px;
    }
    &__detail {
      font-size: 14px;
      line-height: 21px;
      max-height: 63px; // 21 * 3
    }
    &__comment-img {
      margin-top: 12px;
    }
    &__product {
      ::v-deep {
        .comment_pro {
          padding-top: 12px;
        }
        .comment_pro_left {
          height: 48px;
          width: 48px;
        }
        .comment_pro_right {
          line-height: 20px;
          font-size: 14px;
          max-height: 40px; // 20 * 2
        }
      }
    }
  }
}
</style>
